import React from 'react'
import AlternativeStore from '@/components/FulfilmentBox/AlternativeStore/AlternativeStore'
import * as Styled from './AlternativeCollectionBox.styles'
import { AlternativeCollectionTitle } from './AlternativeCollectionTitle'
import { AlternativeStoreButton } from './AlternativeStoreButton'
import { formatAvailabilityMessage } from '../CollectionBox/CollectionMessage'
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage'

export const AlternativeCollectionBox = ({ collectionProps, updateIsInitialMount, chooseAlternativeStore, isV2 }) => {
  const {
    storeLocator: { collectionLoading, alternativeStore, alternativeStoreSelected }
  } = collectionProps

  const showAlternativeCollection =
    !collectionLoading &&
    alternativeStore &&
    alternativeStore.messageKey !== 'COLLECTION_OUT_OF_STOCK' &&
    !alternativeStoreSelected

  if (isV2) {
    return (
      showAlternativeCollection && (
        <AlternativeStore
          leadTimeKey={alternativeStore.skuMessageKey}
          storeName={alternativeStore.storeName}
          onSelectStore={event => chooseAlternativeStore(event, collectionProps, updateIsInitialMount)}
        />
      )
    )
  }

  return (
    showAlternativeCollection && (
      <Styled.FulfilmentMessageAlternative data-test='fulfilment-alternative-store'>
        <AlternativeCollectionTitle alternativeStore={alternativeStore} />

        <AvailabilityMessage
          icon={alternativeStore.icon}
          message={formatAvailabilityMessage(alternativeStore.messaging, alternativeStore.storeName)}
          store={alternativeStore.storeName}
          data-test='alternative-store-availability-message'
        />

        <AlternativeStoreButton
          collectionProps={collectionProps}
          updateIsInitialMount={updateIsInitialMount}
          chooseAlternativeStore={chooseAlternativeStore}
        />
      </Styled.FulfilmentMessageAlternative>
    )
  )
}
